// @flow
import { AppBar, Box, Toolbar } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import dayjs from "dayjs";
import React, { useMemo } from 'react';
import AccountMenu from "../../../components/app/accountmenu/accountMenu";
import LanguageSelect from "../../../components/general/languageSelect/languageSelect";
import Table from "../../../components/grids/table/table";
import UnstructuredTableView from "../../../components/grids/table/partials/views/unstructuredTableView";
import Grid from '@mui/material/Grid2';
import Logo from "../../../components/layout/logo/logo";
import { EventStatus } from "../../../helpers/date";
import ExhibitionPreviewHorizontal from "../../../components/app/exhibitionPreview/exhibitionPreviewHorizontal";
import useExhibitionAction from "../../../hooks/exhibitions/useExhibitionAction";
import { filterExhibitions } from "../../../helpers/filterExhibitions";
import useExhibitionData from "../../../hooks/exhibitions/useExhibitionData";

type Props = {};

const ExhibitorView = (props: Props) => {
	const theme = useTheme();
	const { indexTable } = useExhibitionData()
	const { getExhibitions } = useExhibitionAction()
	const items = filterExhibitions(indexTable.items, {})
	
	const renderRow = useMemo(() =>
		(row) => (
			<Grid key={row.id} size={12}>
				<ExhibitionPreviewHorizontal
					exhibition={row.original}
				/>
			</Grid>
		), [])
	
	const data = {
		loading: indexTable.loading,
		count: items.length,
		items: items.filter(item => {
			const today = dayjs()
			const endDate = item.dateTo
			const inRange =
				today.isAfter(endDate?.subtract(1, "day")) &&
				today.isBefore(endDate?.add(7, "day").add(1, "day"));
			return item.status !== EventStatus.EXPIRED || inRange
		})
	}
	
	return (
		<>
			<AppBar
				position={"absolute"}
				color={'inherit'}
				elevation={0}
				sx={{
					top: 0,
					zIndex: 1200,
					backgroundColor: theme.palette.white.main
				}}
			>
				<Box sx={{ display: 'flex', justifyContent: 'space-between', marginLeft: '2%' }}>
					<Logo width={150} height={70}/>
					<Toolbar
						sx={{
							width: '100%',
							justifyContent: 'flex-end',
							gap: 4
						}}
					>
						<LanguageSelect/>
						<AccountMenu/>
					</Toolbar>
				</Box>
			</AppBar>
			<Box>
				<Table
					data={data}
					columns={[
						{
							header: '',
							accessor: 'id',
						}
					]}
					dataManager={getExhibitions}
					view={UnstructuredTableView}
					noMeta
					noPagination
					renderRow={renderRow}
				/>
			</Box>
		</>
	);
};

export default ExhibitorView